export const GantAddressColumns = [
    'Destination',
    'Deliveryaddress',
    'Buyeraddresscode',
    'Deliveryaddresscode'
]